var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9993 9.44C11.0538 9.44 12.7193 7.7745 12.7193 5.72C12.7193 3.6655 11.0538 2 8.9993 2C6.9448 2 5.2793 3.6655 5.2793 5.72C5.2793 7.7745 6.9448 9.44 8.9993 9.44Z",
    fill: "#BBBBBB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7747 17C14.8973 17.007 15.02 16.9874 15.1343 16.9427C15.2487 16.898 15.3521 16.8292 15.4375 16.741C15.5229 16.6527 15.5883 16.5471 15.6292 16.4313C15.6702 16.3156 15.6857 16.1923 15.6747 16.07C15.1947 13.25 12.3897 11.0825 8.99971 11.0825C5.60971 11.0825 2.80471 13.25 2.32471 16.07C2.31374 16.1923 2.32924 16.3156 2.37017 16.4313C2.4111 16.5471 2.47649 16.6527 2.56188 16.741C2.64728 16.8292 2.75069 16.898 2.86506 16.9427C2.97944 16.9874 3.1021 17.007 3.22471 17H14.7747Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.1e03992b4b88f843ade58acb7dca8968.svg";
export { ForwardRef as ReactComponent };